import React from "react";
import { Row, Col } from "antd";
import classnames from "classnames";
import styles from "@Styles/footer.module.less";
import { host, path } from "@Api";

const image = "https://img.8891.com.tw/next";

const { onlineService } = path;

const now = new Date().getFullYear();

const Footer = ({ footerStyle = {} }) => {
  return (
    <section className={styles["Footer"]} style={footerStyle}>
      <div className={styles["content"]}>
        <Row className={styles["top"]}>
          <Col span={5} className={styles["font-item"]}>
            <i className={styles["foot-newcar-icon"]} />
            <i className={styles["line-icon"]} />
          </Col>
          <Col span={6} className={styles["newcar-desc-find"]}>
            <i className={styles["line-icon"]} />
            <div className={styles["title"]}>新車</div>
            <Row className={styles["item"]}>
              <Col span={7}>
                <a target='_blank' href='https://c.8891.com.tw/Models'>
                  車款大全
                </a>
              </Col>
              <Col span={8} style={{ textAlign: "center" }}>
                <a target='_blank' href='https://c.8891.com.tw/news?t=6'>
                  汽車文章
                </a>
              </Col>
              <Col span={7} style={{ textAlign: "right" }}>
                <a target='_blank' href='https://c.8891.com.tw/photoMovie-index.html'>
                  汽車影音
                </a>
              </Col>
            </Row>
            <Row className={styles["item"]}>
              <Col span={7}>
                <a target='_blank' href='https://c.8891.com.tw/photoModel-compare.html'>
                  車型比較
                </a>
              </Col>
              <Col span={8} style={{ textAlign: "center" }}>
                <a target='_blank' href='https://c.8891.com.tw/article/tag'>
                  文章標籤
                </a>
              </Col>
              <Col span={6}></Col>
            </Row>
          </Col>
          <Col span={6} className={classnames(styles["newcar-desc-find"], styles["tool"])}>
            <i className={styles["line-icon"]} />
            <div className={styles["title"]}>中古車</div>
            <Row className={styles["item"]}>
              <Col span={7}>
                <a target='_blank' href='https://www.8891.com.tw/help-sell.html'>
                  賣中古車
                </a>
              </Col>
              <Col span={8} style={{ textAlign: "center" }}>
                <a target='_blank' href='https://auto.8891.com.tw/'>
                  買中古車
                </a>
              </Col>
              <Col span={7} style={{ textAlign: "right" }}>
                <a target='_blank' href='https://auto.8891.com.tw/?selection=1&page=1'>
                  嚴選中古車
                </a>
              </Col>
            </Row>
            <Row className={styles["item"]}>
              <Col span={7}>
                <a target='_blank' href='https://auto.8891.com.tw?org_top=2'>
                  聯盟中古車
                </a>
              </Col>
              <Col span={8} style={{ textAlign: "center" }}>
                <a target='_blank' href='https://www.8891.com.tw/findBuz-index.html'>
                  中古車商
                </a>
              </Col>
              <Col span={8} style={{ textAlign: "center" }}>
                <a target='_blank' href='https://auto.8891.com.tw/topic'>
                  中古車專題
                </a>
              </Col>
            </Row>
            <Row className={styles["item"]}>
              <Col span={7}>
                <a target='_blank' href='https://www.8891.com.tw/help-s_1.html'>
                  收費標準
                </a>
              </Col>
            </Row>
          </Col>
          <Col span={6} className={styles["desc-ewm"]}>
            <Row className={styles["title"]}>聯絡我們</Row>
            <Row className={styles["row"]} style={{ lineHeight: "26px", marginBottom: "4px" }}>
              電話：02-5572-2088（週一至週日09:00-18:00）
            </Row>
            <Row className={styles["row"]}>傳真：02-5579-3400</Row>
            <Row className={styles["row"]}>信箱：Service@8891.com.tw</Row>
            <Row className={styles["row"]}>
              <a
                className={styles["onlineService"]}
                onClick={() => {
                  window.open(onlineService, "serviceWindow", "width=800,height=600");
                }}
              >
                聯絡客服
              </a>
            </Row>
          </Col>
        </Row>
        <ul className={styles["foot-nav"]}>
          <li>
            <a target='_blank' href='https://www.addcn.com/investment-basic.html' title='投資者專區'>
              投資者專區
            </a>
          </li>
          <li>
            <a target='_blank' href='https://www.8891.com.tw/help-us.html' title='關於我們'>
              關於我們
            </a>
          </li>
          <li>
            <a target='_blank' href='https://www.addcn.com/social-welfare2012.html' title='社會公益'>
              社會公益
            </a>
          </li>
          <li>
            <a target='_blank' href='https://c.8891.com.tw/ads/apply' title='廣告合作'>
              <img className={styles["foot-hot"]} src={`${image}/common/hot.png`} />
              廣告合作
            </a>
          </li>
          <li>
            <a target='_blank' href='https://www.addcn.com.tw/media-report.html?id=4' title='新聞剪輯'>
              新聞剪輯
            </a>
          </li>
          <li>
            <a target='_blank' href='https://www.8891.com.tw/help-laimer.html' title='免責聲明'>
              免責聲明
            </a>
          </li>
          <li>
            <a target='_blank' href='https://www.8891.com.tw/help-sev.html' title='服務條款'>
              服務條款
            </a>
          </li>
          <li>
            <a target='_blank' href='https://www.8891.com.tw/help-pris.html' title='隱私權聲明'>
              隱私權聲明
            </a>
          </li>
          <li>
            <a target='_blank' href='https://www.8891.com.tw/help-links.html' title='免費交換連結'>
              免費交換連結
            </a>
          </li>
          <li>
            <a
              target='_blank'
              href='https://www.addcn.com/app/job-listings?utm_source=8891&utm_medium=link&utm_campaign=hire'
              title='數字徵才'
            >
              數字徵才
            </a>
          </li>
        </ul>
        <ul className={styles["foot-sites"]} style={{ marginTop: "20px" }}>
          <li>
            <a target='_blank' href='https://www.8591.com.tw/' title='8591寶物交易 - 8591.com.tw'>
              台灣8591寶物交易網
            </a>
          </li>
          <li>
            <a target='_blank' href='https://www.8591.com.hk/' title='8591寶物交易 - 8591.com.hk'>
              香港8591寶物交易網
            </a>
          </li>
          {/* <li>
            <a target='_blank' href='https://www.591.com.hk/' title='香港591房屋交易網- 591.com.hk'>
              591房屋交易（香港）
            </a>
          </li> */}
          <li>
            <a target='_blank' href='https://rent.591.com.tw/' title='591租屋 - rent.591.com.tw'>
              591租屋
            </a>
          </li>
          <li>
            <a target='_blank' href='https://sale.591.com.tw/' title='591售屋 - sale.591.com.tw'>
              591售屋
            </a>
          </li>
          <li>
            <a
              target='_blank'
              href='https://store.591.com.tw/house-rentSale.html?storeType=1'
              title='591店面 - store.591.com.tw'
            >
              591店面
            </a>
          </li>
          <li>
            <a target='_blank' href='https://newhouse.591.com.tw/' title='591新建案 - newhouse.591.com.tw'>
              591新建案
            </a>
          </li>
        </ul>
        <ul className={styles["foot-sites"]} style={{ marginTop: "20px" }}>
          <li>
            <a target='_blank' href='https://market.591.com.tw/' title='591實價登錄 - market.591.com.tw'>
              591實價登錄
            </a>
          </li>
          <li>
            <a target='_blank' href='https://news.591.com.tw/' title='591新聞 - news.591.com.tw'>
              591新聞
            </a>
          </li>
          <li>
            <a target='_blank' href='https://100.com.tw/' title='100室內設計 - 100.com.tw'>
              100室內設計
            </a>
          </li>
          <li>
            <a target='_blank' href='https://auto.8891.com.tw/' title='8891中古車網 - 8891.com.tw'>
              8891中古車網
            </a>
          </li>
          <li>
            <a target='_blank' href='https://c.8891.com.tw/' title='8891新車- c.8891.com.tw'>
              8891新車
            </a>
          </li>
          <li>
            <a target='_blank' href='https://www.518.com.tw/' title='518 熊班- 518.com.tw'>
              518 熊班
            </a>
          </li>
          <li>
            <a target='_blank' href='https://www.tasker.com.tw/' title='518 熊班- tasker.com.tw'>
              出任務
            </a>
          </li>
          <li>
            <a target='_blank' href='https://www.518.com.tw/active-ChickPTapp.html' title='518找打工- 518.com.tw'>
              小雞上工
            </a>
          </li>
          <li>
            <a target='_blank' href='https://ask.518.com.tw/' title='518找好公司 - ask.518.com.tw/'>
              518找好公司
            </a>
          </li>
          <li>
            <a target='_blank' href='https://www.945.com.tw/' title='找師傅- 945.com.tw'>
              找師傅
            </a>
          </li>
        </ul>
        <div className={styles["foot-copyright"]}>
          Copyright © 2009-{now} by Addcn Technology Co., Ltd. All Rights reserved.
        </div>
        <div className={styles["foot-approve"]}>
          <i className={styles["approve-icon"]}></i>
          <i className={styles["sgs-icon"]}></i>
        </div>
      </div>
    </section>
  );
};

export default Footer;
